import {useDispatch, useSelector} from 'react-redux';
import {Outlet, useLocation} from 'react-router-dom';

import JsonData from '../../data/data.json';
import {logoutStart} from '../../redux/authAction';
import {selectAuth} from '../../redux/selectors';
import {FooterScreen} from '../FooterScreen';
import {LoginScreen} from '../LoginScreen';
import {Navbar} from '../Navbar';

const LayoutComponent = () => {
  // const hideFooterPaths = ['/cart', '/checkout', '/userhistory'];
  const {showLoginModal} = useSelector(selectAuth);

  return(
    <div className={'flex flex-col min-h-screen'}>
      <Navbar />
      <div className={'md:pt-0 pt-10 mb-16 min-h-screen'}>
        <Outlet className={''} />
      </div>
      <FooterScreen  data={JsonData.FooterData} />
      {showLoginModal && <LoginScreen />}
    </div>
  );
};

export default LayoutComponent;
